export const SaleType = {
  ownOrganization: 0,
  resale: 1,
};
